/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import {
  Table,
  Button,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Input,
  DropdownItem,
  Label,
  Form
} from "reactstrap";
import { templateGetItem, updateTempMessage, addTempMessage, putTempMessage, putTempMessageSuccess } from "../../../redux/request/actions";
import IntlMessages from "../../../helpers/IntlMessages";
import AddNewTemplate from "./modals/AddNewTemplate";
import TemplateMessageTable from "./TemplateMessageTable";
import ScrollButton from '../../../components/gotoTopScrollButton/ScrollButton'

const StaffTemplateMessage = ({ templateMessages, templateGetItem, TempMessageLoading, putTempMessage, updateTempMessage, settings }) => {
  const [dropdownBasicOpen, setDropdownBasicOpen] = useState(false);
  const [dropDownValue, setDropDownValue] = useState(settings.locale === "en" ? "all" : "hepsi");
  const [formLang, setFormLang] = useState("ab");
  const [openEdit, setOpenEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const [itemIndex, setItemIndex] = useState(0);
  const [formTitle, setFormTitle] = useState();
  const [formText, setFormText] = useState();

  const addAllValue = () => {
    if (templateMessages && templateMessages.language && !Object.keys(templateMessages.language).all) {
      templateMessages.language.all = [];
    }
  };

  useEffect(() => {
    templateGetItem();
    addAllValue();
    if (dropDownValue == null) {
      setDropDownValue(settings.locale === "en" ? "all" : "hepsi");
    }
  }, [TempMessageLoading]);

  const toggleEdit = async () => {
    setOpenEdit(!openEdit);
    await templateGetItem();
  };
  const toggle = () => setOpen(!open);

  const toggleBasic = () => {
    addAllValue();
    setDropdownBasicOpen(current => !current);
  };

  const deleteTemp = async (item, langs) => {
    const itemIndex = templateMessages.language[formLang].indexOf(item);
    templateMessages.language[formLang].splice(itemIndex, 1);
    if (Object.keys(templateMessages.language).length > 0) {
      setDropDownValue(settings.locale === "en" ? "all" : "hepsi");
    }
    await putTempMessage(templateMessages);
    if (templateMessages && templateMessages.language && templateMessages.language[formLang] && templateMessages.language[formLang].length > 0) {
      setDropDownValue(formLang);
    }
  };

  const titleHandler = value => {
    templateMessages.language[formLang][itemIndex].title = value;
  };
  const textHandler = value => {
    templateMessages.language[formLang][itemIndex].text = value;
  };
  const updateTemp = item => {
    updateTempMessage(templateMessages);
  };

  if (templateMessages == null) {
    return <p>Loading</p>;
  }

  return (
    <>
      <div className="d-flex flex-row-reverse  ">
        <div>
          {templateMessages.language && (
            <UncontrolledDropdown className="ml-2">
              <Dropdown isOpen={dropdownBasicOpen} toggle={toggleBasic} className="ml-2">
                <DropdownToggle caret color="light" className="language-button">
                  <span className="name">{dropDownValue === "all" ? (settings.locale === "en" ? "All" : "Hepsi") : dropDownValue.toUpperCase()}</span>
                </DropdownToggle>
                <DropdownMenu>
                  {Object.keys(templateMessages.language).map((item, index) => (
                    <DropdownItem key={index}
                      onClick={click => {
                        setDropDownValue(item);
                      }}
                    >
                      {item === "all" ? (settings.locale === "en" ? "All" : "Hepsi") : item.toUpperCase()}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </UncontrolledDropdown>
          )}
        </div>
        <div className="mt-2">
          <Button type="button" onClick={toggle} className="btn outline-light flex-grow-1 ml-3 mr-2 float-right" color="outline-success" size="xs">
            + <IntlMessages id="template.newTemplate" />
          </Button>
        </div>
      </div>
      <>
        {!templateMessages.language && (
          <h3>
            <IntlMessages id="template.noTemplate" />
          </h3>
        )}
      </>
      {templateMessages.language && (
        <>
          <TemplateMessageTable
            templateMessages={templateMessages}
            dropDownValue={dropDownValue}
            setDropDownValue={setDropDownValue}
            setFormLang={setFormLang}
            setFormText={setFormText}
            setFormTitle={setFormTitle}
            deleteTemp={deleteTemp}
            toggleEdit={toggleEdit}
          />
        </>
      )}

      <ScrollButton />

      <>
        <Modal toggle={toggle} isOpen={open}>
          <ModalHeader>
            <IntlMessages id="template.add" />
          </ModalHeader>
          <Form>
            <ModalBody>
              <AddNewTemplate
                setDropDownValue={setDropDownValue}
                setOpen={setOpen}
                open={open}
                setOpenEdit={setOpenEdit}
                formLang={formLang}
                setFormTitle={setFormTitle}
                setFormLang={setFormLang}
                setFormText={setFormText}
              />
            </ModalBody>
          </Form>
        </Modal>
      </>
      <>
        <Modal toggle={toggleEdit} isOpen={openEdit}>
          <ModalHeader>
            <IntlMessages id="template.edit" />
          </ModalHeader>
          <ModalBody>
            <Label>
              {" "}
              <IntlMessages id="template.title" />
            </Label>
            <Input key="code" defaultValue={formTitle} onChange={e => titleHandler(e.target.value)} />
            <Label className="mt-2">
              {" "}
              <IntlMessages id="template.text" />
            </Label>
            <Input key="code" defaultValue={formText} onChange={e => textHandler(e.target.value)} />
          </ModalBody>
          <ModalFooter>
            <Button
              color="light"
              onClick={() => {
                setOpenEdit(!openEdit);
                templateGetItem();
              }}
            >
              <IntlMessages id="template.cancel" />
            </Button>
            <Button
              color="primary"
              onClick={() => {
                setOpenEdit(!openEdit);
                updateTemp();
              }}
            >
              <IntlMessages id="template.save" />
            </Button>
          </ModalFooter>
        </Modal>
      </>
    </>
  );
};
const mapStateToProps = ({ requestApp, settings }) => {
  const { templateMessages, TempMessageLoading, loading } = requestApp;
  return { templateMessages, TempMessageLoading, loading, settings };
};
export default injectIntl(
  connect(
    mapStateToProps,
    {
      putTempMessageSuccess,
      putTempMessage,
      addTempMessage,
      templateGetItem,
      updateTempMessage
    }
  )(StaffTemplateMessage)
);
